import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://b8943a9bc35e7328fbe4d116f21b2362@o291228.ingest.us.sentry.io/4507698354520064",
  integrations: [],
  environment: process.env.REACT_APP_PUI_ENV,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);
